import React from "react";
import {
    Form,
    FormElement,
    FormValidator,
    CustomTextControl,
    BaseReactComponent,
    FormSubmitButton,
    SelectControl,
} from "../../utils/form";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { CustomModal, ImageUploader, Spinner } from "../common";

import { userAmcUuids, userCreatorUuids, userRoleType } from "../../utils/ReusableFunctions";
import { MODALFILETYPE, modalOptions, SUPER_ADMIN } from "../../utils/Constant";
import { updateModalApi } from "./Api";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import ComponentHeader from "../common/ComponentHeader";
import ReactDOM from "react-dom";
import { putAuthCommonApi } from "../content/Api";
import { withRouter } from "../../utils/hoc/withRouter";



const htmlToEditerConvert = (data) => {
    const contentBlock = htmlToDraft(data || '');
    const contentState = ContentState.createFromBlockArray(contentBlock?.contentBlocks);
    const editorState = EditorState.createWithContent(contentState);
    return editorState;
}

class EditModal extends BaseReactComponent {
    constructor(props) {
        super(props);
        const data = props?.location.state?.data || null;
        const roleType = userRoleType() || SUPER_ADMIN;

        this.state = {
            editData: data,
            modalUuid: data?.uuid,
            roleType,
            title: data?.title || "",
            editorState: data ? htmlToEditerConvert(data.description) : EditorState?.createEmpty(),
            htmlRichText: data?.description || null,
            type: data?.type || "",
            subTitle: data?.subTitle,
            resLoading: false,
            successText: data?.successButtonText || "",
            cancelText: data?.cancelButtonText || "",
            code: data?.code || "",
            urlLink: data?.youtubeUrl || "",
            thumbnailFile: null,
            uploadImage: data?.filePath || null,
            uploadFileName: ""
        };
    }

    componentDidMount() {

    }
    componentDidUpdate(prevProps, prevState) {

    }

    onHide = () => {
        this.props.onHide();
    }
    handleSave = () => {
        ReactDOM.findDOMNode(this.form).dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
        );
    };
    imageUploaser = (e, name) => {

        const imageUrl = URL.createObjectURL(e.target.files[0]);
        this.setState({ iconImagePath: e.target.files[0].name, thumbnailFile: e.target.files[0], uploadImage: imageUrl, uploadFileName: e.target.files[0]?.name || '', })

    }
    onValidSubmit = async () => {
        this.setState({ resLoading: true })
        const { title, subTitle, htmlRichText, type, successText, cancelText, code, urlLink } = this.state;

        let modalData = {
            "data": {
                "title": title,
                "subTitle": subTitle,
                "description": htmlRichText,
                "type": type,
                "successButtonText": successText,
                "cancelButtonText": cancelText,
                "code": code,
                "youtubeUrl": urlLink
            }
        };
        const data = new FormData();
        data.append("key", JSON.stringify(modalData));
        data.append("file", this.state?.thumbnailFile);

        if (this.state.modalUuid) {
            const response = await putAuthCommonApi(`modal/${this.state.modalUuid}`, data, this.props.this)
            if (response.status < 250 && response.status > 199) {
                this.setState({ resLoading: false })
                this.props.history({ pathname: `/modal`, search: 'pageSize=10&pageNumber=1' });

            } else {
                this.setState({ resLoading: false })
            }

        } else {


        }

    }

    render() {
        const { uploadImage, amcOption, resLoading, roleType, thumbnailFile, bannerfile, uploadImage2, circleImageFile, uploadImage3, editorState } = this.state;
        return (
            <section className="add-section">

                <ComponentHeader
                    title={this.state.modalUuid ? "Update Modal" : ""}
                    primaryBtn="Save"
                    isBackArrow={true}
                    resLoading={this.state.resLoading}
                    isReturn="/modal?pageSize=10&pageNumber=1"
                    handlePrimaryBtn={this.handleSave}
                />
                <Form ref={(el) => (this.form = el)} onValidSubmit={this.onValidSubmit}>
                    <Row>
                        <Col sm={4}>
                            <FormElement
                                valueLink={this.linkState(this, "title")}
                                label="Title"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Field cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        //   type: "",
                                        placeholder: "Enter Title",
                                    },
                                }}
                            />
                        </Col>

                        <Col sm={4}>
                            <FormElement
                                valueLink={this.linkState(this, "subTitle")}
                                label="Sub Title"

                                // validations={[
                                //     {
                                //         validate: FormValidator.isRequired,
                                //         message: "Field cannot be empty",
                                //     },
                                // ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        //   type: "",
                                        placeholder: "Enter Sub Title",
                                    },
                                }}
                            />
                        </Col>

                        <Col sm={4}>
                            <FormElement
                                valueLink={this.linkState(this, "successText")}
                                label="Success Button Text"

                                // validations={[
                                //     {
                                //         validate: FormValidator.isRequired,
                                //         message: "Field cannot be empty",
                                //     },
                                // ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        //   type: "",
                                        placeholder: "Enter Text",
                                    },
                                }}
                            />
                        </Col>
                        <Col sm={4}>
                            <FormElement
                                valueLink={this.linkState(this, "cancelText")}
                                label="Cancel Button Text"

                                // validations={[
                                //     {
                                //         validate: FormValidator.isRequired,
                                //         message: "Field cannot be empty",
                                //     },
                                // ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        //   type: "",
                                        placeholder: "Enter Text",
                                    },
                                }}
                            />
                        </Col>

                        <Col sm={4}>

                            <FormElement
                                valueLink={this.linkState(this, "type")}
                                label="Select Type"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Field cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: SelectControl,
                                    settings: {
                                        options: modalOptions,
                                        multiple: false,
                                        searchable: true,
                                        onChangeCallback: (onBlur) => {
                                            onBlur(this.state.type);
                                            this.setState({ thumbnailFile: "", uploadImage: "", urlLink: "" })
                                        },
                                    },
                                }}
                            />

                        </Col>

                        {this.state.type === "YOUTUBE" &&
                            <Col sm={4}>
                                <FormElement
                                    valueLink={this.linkState(this, "urlLink")}
                                    label="Enter Url Link"
                                    required
                                    validations={[
                                        {
                                            validate: FormValidator.isRequired,
                                            message: "Field cannot be empty",
                                        },
                                    ]}
                                    control={{
                                        type: CustomTextControl,
                                        settings: {
                                            //   type: "",
                                            placeholder: "Enter Url Link",
                                        },
                                    }}
                                />
                            </Col>
                        }
                        {(this.state.type === "IMAGE" || this.state.type === "VIDEO") &&
                            <Col sm={4}>
                                <ImageUploader required={true} id="contentImage" label="Upload Content" name={typeof (thumbnailFile) == 'object' ? uploadImage : thumbnailFile} onChange={(e) => this.imageUploaser(e, "thumbnail")} acceptedFileType={MODALFILETYPE[this.state.type]}
                                    uploadFileName={this.state.uploadFileName} onDelete={() => this.setState({ thumbnailFile: "" })} />
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col md={8} style={{ zIndex: "0", marginTop: "3rem" }}>
                            <h3 className=" inter-bold f-s-16 black-757 mb-10">Description </h3>
                            <Editor
                                editorStyle={{ height: '160px' }}
                                editorState={editorState}
                                toolbarClassName="toolbarClassName"
                                wrapperClassName="wrapperClassName"
                                editorClassName="editorClassName bg-white inter-regular f-s-14 lh-15 grey-757"
                                onEditorStateChange={(editorState) => {
                                    const htmlContent = draftToHtml(convertToRaw(editorState?.getCurrentContent()));

                                    this.setState({
                                        htmlRichText: htmlContent,
                                        editorState: editorState
                                    });


                                }}
                                toolbar={{
                                    options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'textAlign', 'emoji', 'colorPicker'],
                                    inline: {
                                        inDropdown: false,
                                        options: ['bold', 'italic', 'underline', 'strikethrough']
                                    },
                                    fontSize: {
                                        inDropdown: false,
                                        className: 'd-none',
                                        options: []
                                    },
                                    fontFamily: {
                                        inDropdown: false,
                                        options: [],
                                        className: 'd-none',
                                        component: undefined,
                                        dropdownClassName: undefined,
                                    },
                                    // blockType: {
                                    // inDropdown: true,
                                    // options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code']
                                    // },
                                    blockType: {
                                        inDropdown: false,
                                        options: [],
                                        className: 'd-none',
                                        component: undefined,
                                        dropdownClassName: undefined,
                                    },
                                    list: {
                                        inDropdown: false,
                                        options: []
                                    },
                                    link: {
                                        inDropdown: true,
                                        options: []
                                    },
                                    emoji: {
                                        inDropdown: true,
                                        popupClassName: 'popupEmojiClassName',
                                        emojis: ['✔️', '❌']
                                    },
                                    embedded: {
                                        inDropdown: true,
                                        options: []
                                    },
                                    image: {
                                        inDropdown: true,
                                        options: []
                                    },
                                    history: {
                                        inDropdown: true,
                                        options: []
                                    },
                                    remove: {
                                        visible: false
                                    }
                                }}
                            />
                            <br></br>

                        </Col>
                    </Row>


                </Form>
            </section>

        );
    }
}

const mapStateToProps = state => ({
    // masterCategoryState: state.MasterCategoryState,
});

const mapDispatchToProps = {
    // getAllAmcApi
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditModal));
